import * as React from "react";

function SvgChangeUserStatus(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.958 17.1c2.027-4.551 4.385-11.658-.956-13.057C16.472.036 20.498-.005 20.885 0H20.958c.438-.004 4.62.063 4.906 4.366 0 0 .103 1.44-.022 2.935v.057c0 2.443-.813 4.605-2.06 5.926 1.169.618 2.893 1.522 3.855 1.989 0 0 4.118 1.968 4.36 6.728 0 0 .005.068-.022.17.015.204.022.414.022.629a7.7 7.7 0 00.002.11c0 .075-.002.342-.002 1.157v1.9s-.155.361-.73.84c-1.34-3.107-4.364-5.274-7.88-5.274-.183 0-.366.006-.546.018-1.362-2.003-3.312-3.73-5.883-4.451zm15.041 5.81v-.024.003l.001.01v.012zM23.387 38c4.08 0 7.386-3.403 7.386-7.6 0-4.197-3.307-7.6-7.386-7.6-4.079 0-7.385 3.403-7.385 7.6 0 4.197 3.306 7.6 7.385 7.6zm2.704-8.895h1.82c-.557-1.994-2.372-3.455-4.524-3.455a4.691 4.691 0 00-4.068 2.367l-1.06-1.072V30.4h3.419l-1.081-1.092a2.994 2.994 0 012.79-1.93 2.99 2.99 0 012.704 1.727zm-7.228 2.59h1.82a2.99 2.99 0 002.704 1.728c1.271 0 2.357-.801 2.79-1.93l-1.08-1.093h3.42v3.455l-1.062-1.072a4.691 4.691 0 01-4.068 2.367c-2.152 0-3.966-1.46-4.524-3.454zM11.43 5.067c-8.001 0-5.54 9.5-3.078 13.3-7.385 1.9-9.231 10.766-8 13.3.77 1.584 8.76 2.177 14.941 1.78a9.08 9.08 0 01-.522-3.047c0-3.653 2.147-6.79 5.213-8.148-1.334-1.758-3.151-3.233-5.477-3.885 2.257-5.067 4.923-13.3-3.077-13.3z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgChangeUserStatus;
